"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/50 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "Strategic Pillars",
        href: "/StrategicPillarsPage"
      }, {
        label: "Our Philosophy",
        href: "/OurPhilosophyPage"
      }, {
        label: "Insights",
        href: "/InsightsPage"
      }, {
        label: "Connect",
        href: "/ConnectPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-sm text-muted-foreground/50 transition-colors duration-300 hover:text-foreground">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground/50 transition-colors duration-300 hover:text-foreground">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  return <section data-section-id="264921" id="footer" className="bg-background text-foreground border-t border-border/10 pt-20 pb-8">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-8 mb-16">
          
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-foreground" />
            </Link>
            <p className="text-sm text-muted-foreground/50 font-default leading-relaxed max-w-xs">
              9 Norah Ave, Charmhaven NSW 2263, Australia. Future Mind Consulting (FMC) empowers growth through innovation, technology, and strategic intelligence.
            </p>
          </div>

          <div>
            <h3 className="font-default text-lg font-bold mb-6 tracking-tight text-foreground">Quick Links</h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-default text-lg font-bold mb-6 tracking-tight text-foreground">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground/50 group">
                <span className="transition-colors duration-300 group-hover:text-foreground">
                  Charmhaven, NSW 2263
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground/50 group">
                <span className="transition-colors duration-300 group-hover:text-foreground">
                  0480 891 843
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground/50 group">
                <span className="transition-colors duration-300 group-hover:text-foreground">
                  info@futuremindconsulting.it.com
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground/50 group pt-2">
                <span className="transition-colors duration-300 group-hover:text-foreground">
                  Mon - Fri: 9:00 AM - 6:00 PM
                </span>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="bg-border/10 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground/50 font-mono">
            &copy; {currentYear} Future Mind Consulting. All rights reserved.
          </p>
          
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-muted-foreground/50 hover:text-foreground hover:bg-transparent gap-2 text-xs uppercase tracking-widest font-mono">
            Back to Top
          </Button>
        </div>
      </div>
    </section>;
}